import { render } from "./ProviderDocumentsDialog.vue?vue&type=template&id=6f6edad5"
import script from "./ProviderDocumentsDialog.vue?vue&type=script&lang=js"
export * from "./ProviderDocumentsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__